<template>
	<div class="container">
		<div class="page page-settings">
			<!-- Header -->
			<div class="page-header">
				<div class="row">
					<div class="col-md-9">
						<h1 class="page-title">{{ $t('Slider Banner') }}</h1>
						<div>Atur slider banner untuk ditampilkan di halaman depan</div>
					</div>
					<div class="col-md-3">
						<div class="page-header-right text-right">
							<button class="btn btn-primary" @click="showCreateForm = true">Add Banner</button>
						</div>
					</div>
				</div>
			</div>

			<div class="page-content">
				<!-- Create Banner -->
				<div class="card card-body card-banner-container mb-4" v-if="showCreateForm">
					<div class="d-flex card-banner-header">
						<button class="btn btn-sm btn-plain">
							<i class="bi-plus-circle"></i>
						</button>
						<span class="banner-title align-self-center mr-auto">
							Buat Banner Baru
						</span>
						<!-- <button class="btn btn-sm btn-plain drag-item" v-tooltip="'Click to expand'" data-toggle="collapse" :data-target="`#section${banner._id}`" aria-expanded="false" :aria-controls="`section${banner._id}`">
							<i class="bi-chevron-down"></i>
						</button> -->
					</div>
					<div class="mt-2 p-3">
						<div class="form-group">
							<label for="title">Judul Banner</label>
							<input type="text" class="form-control" v-model="title" id="title" placeholder="Judul banner" required>
						</div>
						<div class="form-group">
							<label for="url">Link To</label>
							<input type="text" class="form-control" v-model="url" id="url" placeholder="Input url for banner" required>
						</div>
						<div class="row">
							<div class="col-md-6">
								<div class="form-group">
									<label for="image">Upload Banner Promosi Desktop</label>
									<button class="btn btn-sm btn-plain text-danger" v-if="previewImage !== ''" @click="previewImage = ''">
										<i class="bi-x-circle"></i> Remove Image
									</button>
									<div class="my-2 text-center preview-image" v-if="previewImage !== ''">
										<img class="img-fluid rounded" :src="previewImage" alt="Uploaded Image">
									</div>
									<div
										v-if="isUploading && previewImage === ''"
										class="pc-image-empty"
									>
										<div class="image-loading">
											<div class="is-loading"></div>
										</div>
									</div>
									<div
										v-else-if="previewImage === ''"
										class="pc-image-empty cursor-pointer"
										@click="uploadImage('desktop_image')"
									>
										<div class="image-upload-placeholder">
											<i class="fi fi-rr-picture image-placeholder"></i>
											<div class="text-placeholder">
												Klik untuk upload.
											</div>
										</div>
									</div>
									<div class="pc-input-desc">
										Upload image dengan resolusi 1296x324px agar fit dengan ukuran banner.
									</div>
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label for="image">Upload Banner Promosi Mobile (optional)</label>
									<button class="btn btn-sm btn-plain text-danger" v-if="previewImageMobile !== ''" @click="previewImageMobile = ''">
										<i class="bi-x-circle"></i> Remove Image
									</button>
									<div class="my-2 text-center preview-image" v-if="previewImageMobile !== ''">
										<img class="img-fluid rounded" :src="previewImageMobile" alt="Uploaded Image">
									</div>
									<div
										v-if="isUploadingMobile && previewImageMobile === ''"
										class="pc-image-empty"
									>
										<div class="image-loading">
											<div class="is-loading"></div>
										</div>
									</div>
									<div
										v-else-if="previewImageMobile === ''"
										class="pc-image-empty cursor-pointer"
										@click="uploadImage('mobile_image')"
									>
										<div class="image-upload-placeholder">
											<i class="fi fi-rr-picture image-placeholder"></i>
											<div class="text-placeholder">
												Klik untuk upload.
											</div>
										</div>
									</div>
									<div class="pc-input-desc">
										Upload image dengan resolusi 1518x759px agar fit dengan ukuran banner.
									</div>
								</div>
							</div>
						</div>
						<div class="form-group buttons m-0 hidden">
							<input
								type="file"
								accept="image/*"
								class="input-file"
								ref="imageUploader"
								id="pc-product-images-file"
								@change="onInputImageChange"
								multiple
							/>
							<label
								for="pc-product-images-file"
								class="btn btn-primary"
								:class="{ 'is-loading': isFetching }"
								>Upload images</label
							>
							<div class="pc-input-desc">
								Make sure your image resolution is 1296x324 px
							</div>
						</div>
						<div class="mt-3 pull-right">
							<button type="button" class="btn-outline o-md outline-primary mr-2" @click="showCreateForm = false">Cancel</button>
							<button type="button" class="btn-outline o-md outline-primary active" @click="createBanner">Submit</button>
						</div>
					</div>
				</div>

				<!-- List -->
				<draggable
					v-model="banners"
					group="people"
					@start="drag=true"
					@end="onDraggedEnd"
					handle=".drag-item"
				>
					<div class="card card-body card-banner-container mb-4" v-for="banner in banners" :key="banner._id">
						<div class="d-flex card-banner-header">
							<button class="btn btn-sm btn-plain drag-item" v-tooltip="'Drag to order'">
								<i class="bi-grip-vertical"></i>
							</button>
							<span class="banner-title align-self-center mr-auto">
								{{ banner.data.title }}
							</span>
							<button class="btn btn-sm btn-plain" v-tooltip="'Remove this banner'" @click="showRemoveModal(banner._id)">
								<i class="bi-x-lg"></i>
							</button>
							<button class="btn btn-sm btn-plain drag-item" v-tooltip="'Click to expand'" data-toggle="collapse" :data-target="`#section${banner._id}`" aria-expanded="false" :aria-controls="`section${banner._id}`">
								<i class="bi-chevron-down"></i>
							</button>
						</div>
						<div class="collapse" :id="`section${banner._id}`">
							<div class="card-body">
								<div>
									<label>Banner Promosi Desktop</label>
									<div class="text-center my-2">
										<img class="img-fluid rounded" :src="banner.data.image" alt="">
									</div>
								</div>
								<div v-if="banner.data.image_mobile">
									<label>Banner Promosi Mobile</label>
									<div class="text-center my-2">
										<img class="img-fluid rounded" :src="banner.data.image_mobile" alt="">
									</div>
								</div>
								<strong>Link to : {{ banner.data.url }}</strong>
							</div>
						</div>
					</div>
				</draggable>

				<!-- debug : for dev only -->
				<!-- <hr>
				<div>
					{{ banners }}
				</div> -->
			</div>
		</div>

		<notifications group="admin-sliders" position="bottom right" />
		<!-- Modal Change Status -->
		<modal
			class="table-change-status-modal"
			size="medium"
			@close="isConfirmDelete = false"
			v-if="isConfirmDelete">
			<div slot="header">
				<h3>Confirm Status</h3>
			</div>
			<div slot="body">
				<div class="text-left">
					Are you sure want to remove this banner ?
				</div>
			</div>
			<div slot="footer">
				<button type="button" class="btn btn-light" @click="isConfirmDelete = false">{{ $t('Close') }}</button>
				<button type="button" class="btn btn-danger" @click="removeBanner(selectedBannerId)">Remove</button>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import homepageApi from '@/api/homepage';
import mediaApi from '@/api/media';
import Modal from '@/components/Modal.vue';
import { getAxiosErrorMessage } from '@/lib/helper';

export default {
	name: 'AdminSlider',
	components: {
		draggable,
		Modal,
	},
	data() {
		return {
			keyword: '',
			limit: 20,
			page: 1,
			sort_by: 'data.sort',
			sort: 'asc',
			isFetching: false,
			isSaveChange: false,
			params: [],
			currentApprovalTime: '',
			productApprovalTime: '',
			banners: [],
			showCreateForm: false,
			title: '',
			image: '',
			imageMobile: '',
			url: '',
			previewImage: '',
			previewImageMobile: '',
			isUploading: false,
			isUploadingMobile: false,
			stateUpload: 'desktop_image',
			selectedBannerId: null,
			isConfirmDelete: false,
		};
	},
	methods: {
		...mapActions({}),
		showRemoveModal(id) {
			this.isConfirmDelete = true;
			this.selectedBannerId = id;
		},
		fetchBanners() {
			this.isFetching = true;

			const params = {
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
				// status: this.status,
			};

			const callback = (response) => {
				const banners = response.data;
				this.banners = banners;
				this.isFetching = false;
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			homepageApi.getBanner(params, callback, errorCallback);
		},
		uploadImage(state) {
			console.log('up');
			this.stateUpload = state;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onInputImageChange(event) {
			if (this.stateUpload === 'desktop_image') {
				this.image = '';
				this.previewImage = '';
				this.isUploading = true;
			} else if (this.stateUpload === 'mobile_image') {
				this.imageMobile = '';
				this.previewImageMobile = '';
				this.isUploadingMobile = true;
			}
			const maxUploadSize = 3; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 3MB)`;
					this.$notify({
						group: 'admin-sliders',
						text: noticeMessage,
						type: 'warn',
					});
					this.isUploading = false;
					this.isUploadingMobile = false;
					break;
				}

				// Start Upload
				const uploadParams = new FormData();
				uploadParams.append('image', image);

				const callback = (response) => {
					this.isUploading = false;
					const path = response.data;
					const url = `${this.mediaUrlPrefix}/${path}`;

					if (this.stateUpload === 'desktop_image') {
						this.image = url;
						this.previewImage = url;
						this.isUploading = false;
					} else if (this.stateUpload === 'mobile_image') {
						this.imageMobile = url;
						this.previewImageMobile = url;
						this.isUploadingMobile = false;
					}
				};

				const errorCallback = (e) => {
					this.isUploading = false;
					console.log(e);
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
			event.target.files = null;
			event.target.value = '';
		},
		createBanner() {
			if (this.title === '' || this.image === '' || this.url === '') {
				this.$notify({
					group: 'admin-sliders',
					title: 'Create Banner',
					text: 'Semua inputan harus diisi.',
					type: 'error',
				});
			} else {
				this.isFetching = true;
				const params = {
					title: this.title,
					image: this.image,
					image_mobile: this.imageMobile,
					url: this.url,
				};

				const callback = (response) => {
					// const banners = response.data;
					const message = response.message;
					this.$notify({
						group: 'admin-sliders',
						title: 'Create Banner',
						text: message,
						type: 'success',
					});
					this.fetchBanners();
					this.title = '';
					this.image = '';
					this.imageMobile = '';
					this.url = '';
					this.previewImage = '';
					this.previewImageMobile = '';
					this.isFetching = false;
					this.showCreateForm = false;
				};

				const errorCallback = (e) => {
					const message = getAxiosErrorMessage(e);
					this.$notify({
						group: 'admin-sliders',
						title: 'Create Banner',
						text: message,
						type: 'error',
					});
					this.isFetching = false;
				};

				homepageApi.createBanner(params, callback, errorCallback);
			}
		},
		removeBanner(id) {
			this.isFetching = true;

			const callback = (response) => {
				// const banners = response.data;
				const message = response.message;
				this.$notify({
					group: 'admin-sliders',
					title: 'Delete Banner',
					text: message,
					type: 'success',
				});
				this.fetchBanners();
				this.isFetching = false;
				this.isConfirmDelete = false;
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'admin-sliders',
					title: 'Delete Banner',
					text: message,
					type: 'error',
				});
				this.isFetching = false;
			};

			homepageApi.deleteBanner(id, callback, errorCallback);
		},
		onDraggedEnd() {
			this.drag = false;
			const params = {
				banners: JSON.stringify(this.banners),
			};

			const callback = () => {
				this.fetchBanners();
			};
			const errorCallback = () => {
				this.$notify({
					group: 'app',
					title: 'Supplier Banner',
					text: 'Failed to Change Order',
					type: 'error',
				});
			};

			homepageApi.changeOrderBanner(params, callback, errorCallback);
		},
	},
	computed: {
		...mapGetters({}),
	},
	created() {
		this.fetchBanners();
	},
};
</script>
<style lang="scss" scoped>
	.card-banner-container {
		border: 2px solid #4D4D4D;
		border-radius: 10px;

		// .card-banner-header {
		// 	border-bottom: 2px solid #ADB5BD;
		// 	padding-bottom: 20px;
		// }

		.banner-title {
			font-weight: 700;
			font-size: 22px;
			line-height: 120%;
		}

		.drag-item {
			font-weight: 700;
			font-size: 16px;
		}

		label {
			font-weight: 700;
			font-size: 16px;
			line-height: 150%;
		}

		.form-control {
			border: 2px solid #1F1F1F61;
			height: calc(2.3em + 0.75rem + 2px);
		}
	}
</style>
